export function sendTokenToExtension(extensionId, token) {
  return new Promise((resolve, reject) => {
    const runtime = typeof window !== 'undefined' ? window.chrome?.runtime : null;
    if (!runtime || typeof runtime.sendMessage !== 'function') {
      reject(new Error('Chrome extension messaging is unavailable'));
      return;
    }

    runtime.sendMessage(
      extensionId,
      { type: 'AUTH_SUCCESS', token },
      (response) => {
        if (runtime.lastError) {
          reject(new Error(runtime.lastError.message));
          return;
        }
        resolve(response);
      }
    );
  });
}
